import { render } from "./ScreenQuestionSlider.vue?vue&type=template&id=e7465a9c&ts=true"
import script from "./ScreenQuestionSlider.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__